const cards = [
  {
    title: '最新动作大片合集',
    desc: '肾上腺素飙升的硬核动作电影，枪战、追车、格斗一网打尽，高清画质带来沉浸式观影体验。',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20movie%20scene%20with%20dramatic%20explosions%20and%20motion%20blur%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20cinematic%20lighting%20with%20lens%20flares%2C%20intense%20atmosphere%2C%20film%20poster%20style%20composition&width=800&height=500&seq=card-action-01&orientation=landscape',
    tag: '动作',
  },
  {
    title: '喜剧电影欢乐专场',
    desc: '精选国内外高分喜剧，从黑色幽默到温情笑料，让您在笑声中放松身心，享受治愈时刻。',
    img: 'https://readdy.ai/api/search-image?query=Bright%20and%20cheerful%20comedy%20movie%20scene%20with%20warm%20lighting%2C%20playful%20composition%20with%20vibrant%20colors%2C%20feel-good%20atmosphere%2C%20soft%20golden%20highlights%2C%20cinematic%20but%20lighthearted%20aesthetic&width=800&height=500&seq=card-comedy-02&orientation=landscape',
    tag: '喜剧',
  },
  {
    title: '影史经典佳作回顾',
    desc: '收录豆瓣高分、IMDb经典之作，从黑白老片到千禧年名片，致敬那些永不褪色的银幕传奇。',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20classic%20film%20aesthetic%20with%20sepia%20tones%20and%20soft%20film%20grain%2C%20nostalgic%20cinema%20atmosphere%2C%20old%20Hollywood%20glamour%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20elegant%20composition&width=800&height=500&seq=card-classic-03&orientation=landscape',
    tag: '经典',
  },
  {
    title: '华语佳片精选',
    desc: '汇集两岸三地优秀华语电影，从文艺片到商业大片，感受母语电影的情感共鸣与文化深度。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20cinema%20artistic%20scene%20with%20warm%20red%20and%20gold%20tones%2C%20traditional%20and%20modern%20fusion%20aesthetic%2C%20soft%20lantern%20lighting%2C%20elegant%20composition%20with%20cultural%20elements%2C%20cinematic%20mood&width=800&height=500&seq=card-chinese-04&orientation=landscape',
    tag: '华语',
  },
  {
    title: '科幻奇幻视听盛宴',
    desc: '从硬科幻到史诗奇幻，震撼视觉特效与宏大世界观，带来超越现实的观影体验。',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20science%20fiction%20movie%20scene%20with%20neon%20accents%20and%20deep%20space%20atmosphere%2C%20dramatic%20lighting%20with%20cyan%20and%20warm%20orange%20highlights%2C%20epic%20scale%2C%20cinematic%20composition%20with%20atmospheric%20haze&width=800&height=500&seq=card-scifi-05&orientation=landscape',
    tag: '科幻',
  },
  {
    title: '高分纪录片推荐',
    desc: '精选自然、人文、历史类高分纪录片，拓展视野，感受真实世界的力量与美好。',
    img: 'https://readdy.ai/api/search-image?query=Documentary%20film%20aesthetic%20with%20natural%20landscape%20and%20warm%20earth%20tones%2C%20soft%20natural%20lighting%2C%20contemplative%20atmosphere%2C%20cinematic%20wide%20shots%20with%20textured%20surfaces%2C%20elegant%20composition&width=800&height=500&seq=card-doc-06&orientation=landscape',
    tag: '纪录',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            热门推荐
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            精选本周最受欢迎的高清影片，涵盖动作、喜剧、经典、科幻等多元类型
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card) => (
            <article
              key={card.title}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-accent-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors duration-200">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
                <div className="mt-4 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-eye-line"></i>
                    </span>
                    高清
                  </span>
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-line"></i>
                    </span>
                    推荐
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}